import { Grid, ThemeProvider, Typography, useTheme } from '@mui/material'
import { useState, useEffect } from 'react'


interface IParams {
    type: string;
    msg: string; 
    other: any;
}

function Message(params: IParams) {

    const [visible, setVisible] = useState(false)
    const theme = useTheme();
    useEffect(() => {

        if (!params.msg) {
            setVisible(false)
        }
        setVisible(true)
        const timer = setTimeout(() => {
            setVisible(false)

        }, 3000)

        return () => clearTimeout(timer)
    }, [])

    return (<>
        {visible && (
            <Grid container width="100vw" display="flex" justifyItems="center"  paddingTop={2} >
                <ThemeProvider theme={theme} >
                    <Typography variant='body2' color={params.type === "succsess" ? "blue": "red"}>
                        {params.msg} 
                    </Typography>
                </ThemeProvider>
                
            </Grid>
        )}
    </>
    )
}

export default Message